import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import {
    CuentaCorporate,
    OperacionCorporate,
    schemaCuentasCorporate,
    schemaOperacionCorporate
} from '../types/types'
import { BaseResponse } from 'src/types'
import {
    OperacionCorporateCuentaDetalleUpdate,
    OperacionCorporateCuentaInsert,
    OperacionCorporateCuentaUpdate,
    OperacionCorporateInsert,
    OperacionCorporateUpdate,
    schemaOperacionCorporateCuentaDetalleUpdate,
    schemaOperacionCorporateCuentaInsert,
    schemaOperacionCorporateCuentaUpdate,
    schemaOperacionCorporateInsert,
    schemaOperacionCorporateUpdate
} from '../types/dto'

export const getEndpoint = (url = '') => `operaciones/corporate${url}`

export const HttpCorporate = {
    get: (idOperacion: number): Promise<OperacionCorporate> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionCorporate.safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    put: (idOperacion: number, operacion: OperacionCorporateUpdate): Promise<BaseResponse> => {
        const parsed = schemaOperacionCorporateUpdate.safeParse(operacion)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}`), parsed.data) // TODO: parsed.data, no operacion
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    post: (operacion: OperacionCorporateInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionCorporateInsert.safeParse(operacion)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    getCuentas: (idOperacion: number): Promise<CuentaCorporate[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}/cuentas`))
            .then(response => {
                const parsed = schemaCuentasCorporate.safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    postCuenta: (idOperacion: number, cuenta: OperacionCorporateCuentaInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionCorporateCuentaInsert.safeParse(cuenta)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(`/${idOperacion}/cuentas`), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    putCuenta: (
        idOperacion: number,
        idCuenta: number,
        detalle: OperacionCorporateCuentaUpdate
    ): Promise<BaseResponse> => {
        const parsed = schemaOperacionCorporateCuentaUpdate.safeParse(detalle)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}/cuentas/${idCuenta}`), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    deleteCuenta: (idOperacion: number, idCuenta: number): Promise<BaseResponse> => {
        return HttpAxiosRequest.delete(getEndpoint(`/${idOperacion}/cuentas/${idCuenta}`))
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    // Atención acá! Le venía llamando "detalle" a las cuentas, pero a partir de acá lo que antes
    // se llamaba "detalle" ahora es "cuenta". O sea, en la siguiente función, "idCuenta" es lo
    // que antes era "idDetalle", e "idDetalle" es el id de cada detalle DENTRO de una cuenta.
    // TODO: arreglar esta nomenclatura, claro.

    putCuentaDetalle: (
        idOperacion: number,
        idCuenta: number,
        idDetalle: number,
        detalle: OperacionCorporateCuentaDetalleUpdate
    ): Promise<BaseResponse> => {
        const parsed = schemaOperacionCorporateCuentaDetalleUpdate.safeParse(detalle)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.put(
            getEndpoint(`/${idOperacion}/cuentas/${idCuenta}/detalles/${idDetalle}`),
            parsed.data
        )
            .then(res => Promise.resolve(res))
            .catch(err => Promise.reject(err))
    },

    descargarInforme: (idOperacion: number): Promise<any> => {
        const endpoint = getEndpoint(`/${idOperacion}/informe/descargar`)

        return HttpAxiosRequest.getBlob(endpoint)
    }
} as const
